import gql from 'graphql-tag'

export const GetFiltersQuery = gql`
  query filters {
    filters {
      name
      options {
        filterId: id
        name
      }
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ProductCatalogueV2/data.ts